<div class="detail-content-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px"
	fxLayoutGap.xs="15px">
	<div class="detail-content-header" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
		<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
			<div class="descrip-block">
				<app-readability class="app-readability" [height]="(resourceDetail?.description) ? '18' : '0'">
					<content>
						<div class="fx-column fx-start-stretch">
							<ng-container *ngIf="resourceDetail?.description">
								<div class="resource-description">
									{{resourceDetail?.description}}
								</div>
							</ng-container>
							<ng-container *ngIf="resourceDetail?.skills?.length && skillMPermission">
								<div class="skill-pack fx-row-wrap fx-start-start">
									<ng-container *ngFor="let skill of resourceDetail?.skills">
										<app-chips type="progressive" background="var(--secondary-four)"
											[data]="{title: skill?.skill?.value, progress: skill?.skillLevel + '%', bufferColor: 'transparent', toolTip: true}">
										</app-chips>
									</ng-container>
								</div>
							</ng-container>
						</div>
					</content>
				</app-readability>
			</div>
		</div>
	</div>
	<div class="detail-content-body" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
		<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
			<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px" class="submission-block">
				<div class="submission-content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
					<div class="event-view-block" fxLayout="column" fxLayoutAlign="start stretch">
						<div fxFlex="1 1" fxLayout="row wrap" fxLayoutAlign="start start" fxLayoutGap="17px"
							fxLayoutAlign.xs="start stretch" fxLayoutGap.xs="0px">
							<div fxFlex="0 1 350px" fxFlex.xs="1 1" class="thumbnail-block" fxLayout="column"
								fxLayoutAlign="start stretch" fxLayoutGap="7px" fxLayoutGap.xs="9px">
								<div class="thumbnail cursor-pointer" (click)="embedLink()">
									<img [src]="resourceDetail?.resource?.thumbnail | safeDom : 'url'"
										(error)="gfService.setErrorImage($event, 'broken_image')" alt="">
								</div>
								<ng-container *ngIf="showCount">
									<div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutAlign.xs="center center"
										fxLayoutGap="12px" fxLayoutGap.xs="20px">
										<div class="queue cursor-pointer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px"
											(click)="requestForm('registration')">
											<span class="body-text">{{ locale.translate('registrations')}}</span>
											<span class="count-set" fxLayoutAlign="center center">{{ resourceDetail?.registrationCount
												}}</span>
										</div>
										<div class="queue cursor-pointer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px"
											(click)="requestForm('requests')">
											<span class="body-text">{{ locale.translate('requests')}}</span>
											<span class="count-set" [ngClass]="{ 'warn' : (resourceDetail?.registrationRequestCount > 0) }"
												fxLayoutAlign="center center">{{
												resourceDetail?.registrationRequestCount }}</span>
										</div>
									</div>
								</ng-container>
							</div>
							<div class="event-right-block" fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="20px"
								fxLayoutGap.xs="10px">
								<div fxFlex="0 1 414px" fxFlex.xs="1 1" fxLayout="column" fxLayoutAlign="start stretch"
									fxLayoutGap="20px" fxLayoutGap.xs="10px">
									<div class="forum" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="6px">
										<div class="patch-big custom-patch golden" [ngClass]="{'expired': resourceDetail?.datePassed}"
											fxLayout="row" fxLayoutAlign="center center">
											<span>{{resourceDetail?.eventDate}}</span>
											<span>{{resourceDetail?.eventMonth}}</span>
										</div>
										<ng-container *ngIf="resourceDetail?.resource?.link">
											<span class="event-link sub-caption-1 linkable"
												(click)="embedLink()">{{resourceDetail?.resource?.link}}</span>
										</ng-container>
									</div>
									<ng-container *ngIf="resourceDetail?.infoFields?.notes">
										<div fxFlex="1 1" class="forum" fxLayout="row wrap" fxLayoutAlign="start start" fxLayoutGap="6px">
											<span class="body-text">{{resourceDetail?.infoFields?.notes}}</span>
										</div>
									</ng-container>
									<ng-container *ngIf="resourceDetail?.registrationStatus?.key !== 'noShow'">
										<app-registration-workflow [resourceDetail]="resourceDetail" [popupRef]="popupRef"
											(readLog)="emitReadLog()">
										</app-registration-workflow>
									</ng-container>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="feature-placeholder fx-column fx-start-stretch"
			[ngStyle]="{'display': detectDevice?.resolutionState$?.value?.deviceType === 'mobile' ? 'block' : 'none'}">
		</div>
	</div>
</div>
